import {
    ADD_ALGOLIA_RESULTS,
    RESET_ALGOLIA_RESULTS
} from '../mutation-types'

const state = {
    results: [],
}

const getters = {
    results: state => state.results,
}

const actions = {
    addResults({commit}, results) {
        commit(ADD_ALGOLIA_RESULTS, results)
    },
    resetResults({commit}) {
        commit(RESET_ALGOLIA_RESULTS)
    },
}

const mutations = {
    [ADD_ALGOLIA_RESULTS](state, results) {
        state.results = results.filter((v, i, a) => a.findIndex(t => (t.title === v.title)) === i)
    },
    [RESET_ALGOLIA_RESULTS](state) {
        state.results = []
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
